import React from 'react';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import FileAttachments from '../../../../components/FileAttachments/FileAttachments';
import OutlookTitle from './OutlookTitle';
import {Box, Text} from '../../../../styled';


const OutlookSnippet = ({ item }:any) => (
  <>
    <OutlookTitle title={item.title} sender={item.sender} />
    <Box marginBottom={20} marginTop={10}>
      <HighlightMarker>
        {item.resultSnippet}
      </HighlightMarker>
    </Box>

    <FileAttachments files={item.att} />
    <Text variant="muted" size="small" >
      {item.email} | {item.date || 'Not available'}
    </Text>
  </>
);

export default OutlookSnippet;